import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const THREAD_HISTORY = createAsyncActionTypes('THREAD_HISTORY');